import React from 'react';
import { cn } from '@/lib/utils';
import FadeIn from './animations/FadeIn';

interface HowItWorksProps {
  className?: string;
}

const HowItWorks: React.FC<HowItWorksProps> = ({ className }) => {
  const steps = [
    {
      number: "1",
      title: "Fill the Form",
      description: "Tell us about your loved one and your special message"
    },
    {
      number: "2", 
      title: "We Create",
      description: "Our team designs your personalized Sparks website"
    },
    {
      number: "3",
      title: "You Share",
      description: "Get your custom URL and share it with your special someone"
    }
  ];

  return (
    <section className={cn('py-20 bg-white', className)}>
      <div className="container mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <FadeIn>
            <h2 className="text-3xl md:text-4xl font-serif font-medium mb-6">
              How It Works
            </h2>
            <p className="text-lg text-gray-600 mb-16">
              Creating your perfect Sparks website is simple and quick
            </p>
          </FadeIn>

          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <FadeIn key={step.number} delay={200 + index * 100}>
                <div className="text-center">
                  <div className="w-16 h-16 bg-pink-500 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4">
                    {step.number}
                  </div>
                  <h3 className="text-xl font-semibold mb-2">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;